import {Storage} from '.';

const {default: storage} = require('./storage');
export default storage as Storage;
